import AdminModal from './AdminModal';

export default function SaveSuccessDialog({
  open,
  title,
  message,
  error,
  onClose,
  okLabel = 'OK',
}) {
  const dialogTitle = title || (error ? 'Save failed' : 'Saved to server');

  return (
    <AdminModal
      open={open}
      onClose={onClose}
      title={dialogTitle}
      size="sm"
      footer={
        <button type="button" className="admin-btn admin-btn--primary" onClick={onClose}>
          {okLabel}
        </button>
      }
    >
      <p className="admin-modal__message">{message}</p>
      {error ? <p className="admin-error" style={{ marginTop: 12 }}>{error}</p> : null}
    </AdminModal>
  );
}
